export default __webpack_public_path__ + "static/media/logoNav.3f41f087.png";